import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppBar, Typography, IconButton, Button, Drawer, Box } from '@mui/material';
import {
  Menu as MenuIcon,
  
} from '@mui/icons-material';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';
import useResponsive from '../../hooks/useResponsive';
import { HeaderBar, Left, Right, DesktopMenu } from './PublicHeader.styles';
import NavigationDrawer from '../NavigationDrawer/NavigationDrawer';

function PublicHeader() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isMobile, isTablet } = useResponsive();
  const [open, setOpen] = useState(false);

  const toggle = useCallback(() => setOpen(v => !v), []);

  const go = (path) => {
    setOpen(false);
    navigate(path);
  };

  const isSmall = isMobile || isTablet;

  return (
    <AppBar position="static" color="default" elevation={1} >
      <HeaderBar>
        <Left>
          {isSmall && (
            <IconButton edge="start" color="inherit" aria-label="menu" onClick={toggle}>
              <MenuIcon />
            </IconButton>
          )}
          <Box display="flex" alignItems="center" gap={1}>
            <Typography
              variant="h6"
              sx={{ fontWeight: 'bold', cursor: 'pointer', flexShrink: 0 }}
              onClick={() => go('/')}
            >
              StandStrong
            </Typography>
            <img 
              src="/desk.png" 
              alt="Desk icon" 
              style={{ 
                width: isMobile ? '20px' : '30px', 
                height: isMobile ? '20px' : '30px',
                filter: 'brightness(0) invert(1)'
              }} 
            />
          </Box>
        </Left>

        {!isSmall && (
          <DesktopMenu>
            <Button color="inherit" onClick={() => go('/blog')}>{t('blog')}</Button>
            <Button color="inherit" onClick={() => go('/about')}>{t('aboutUsTitle')}</Button>
            <Button color="inherit" onClick={() => go('/contact')}>{t('contactTitle')}</Button>
          </DesktopMenu>
        )}

        <Right>
          {!isSmall && <LanguageSwitcher />}
          {!isSmall && (
            <Button variant="outlined" onClick={() => go('/login')}>
              {t('signIn')}
            </Button>
          )}
        </Right>
      </HeaderBar>

      {/* Drawer for mobile/tablet */}
      <Drawer anchor="left" open={open} onClose={toggle}>
        <NavigationDrawer
          mode="public"
          onMenuClick={(action) => {
            if (action === 'blog') go('/blog');
            else if (action === 'about') go('/about');
            else if (action === 'contact') go('/contact');
            else if (action === 'privacy') go('/privacy');
            else if (action === 'terms') go('/terms');
            else if (action === 'login') go('/login');
          }}
        />
      </Drawer>
    </AppBar>
  );
}

export default PublicHeader;
